export default __webpack_public_path__ + "media/images/features/ana/airplane-a6e01e1c96eb1e797df5b63e775a52c2.png";